import { render } from "./promotions-banner.vue?vue&type=template&id=b51d3956&scoped=true"
import script from "./promotions-banner.vue?vue&type=script&lang=js"
export * from "./promotions-banner.vue?vue&type=script&lang=js"

import "./promotions-banner.vue?vue&type=style&index=0&id=b51d3956&scoped=true&lang=css"

import exportComponent from "C:\\Users\\daniel.montano\\Desktop\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b51d3956"]])

export default __exports__